import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { AvailabilityResponse } from '@/api/types';

export function useAvailability(params: {
  locationId: string;
  sportCode: string;
  date: string;
  duration: number;
  playerCount: number;
}) {
  const searchParams = new URLSearchParams({
    locationId: params.locationId,
    sportCode: params.sportCode,
    date: params.date,
    duration: String(params.duration),
    playerCount: String(params.playerCount),
  });

  return useQuery({
    queryKey: ['availability', params],
    queryFn: () =>
      apiClient<AvailabilityResponse>(`/availability?${searchParams.toString()}`, {
        skipAuth: true,
      }),
    enabled: !!params.locationId && !!params.sportCode && !!params.date,
  });
}
